import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./components/landing/Landing";
import Dashboard from "./pages/Dashboard";
import CreateSession from "./pages/CreateSession";
import SessionWorkspace from "./pages/SessionWorkspace";
import SessionReport from "./pages/SessionReport";
import Marketplace from "./pages/Marketplace";
import Profile from "./pages/Profile";
import AgentsCatalog from "./pages/AgentsCatalog";
import PublicReport from "./pages/PublicReport";
import ResetPassword from "./pages/ResetPassword";
import Billing from "./pages/Billing";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import AdminPanel from "./pages/AdminPanel";
import BecomeExpert from "./pages/BecomeExpert";
import ExpertProfile from "./pages/ExpertProfile";
import ExpertDashboard from "./pages/ExpertDashboard";
import MyReviews from "./pages/MyReviews";

function LandingOrRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id during render, not in useEffect (prevents race)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingOrRedirect />} />
      <Route path="/shared/:token" element={<PublicReport />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/sessions/new" element={<ProtectedRoute><CreateSession /></ProtectedRoute>} />
      <Route path="/sessions/:id/workspace" element={<ProtectedRoute><SessionWorkspace /></ProtectedRoute>} />
      <Route path="/sessions/:id/report" element={<ProtectedRoute><SessionReport /></ProtectedRoute>} />
      <Route path="/agents" element={<ProtectedRoute><AgentsCatalog /></ProtectedRoute>} />
      <Route path="/marketplace" element={<ProtectedRoute><Marketplace /></ProtectedRoute>} />
      <Route path="/become-expert" element={<ProtectedRoute><BecomeExpert /></ProtectedRoute>} />
      <Route path="/experts/:slug" element={<ProtectedRoute><ExpertProfile /></ProtectedRoute>} />
      <Route path="/expert-dashboard" element={<ProtectedRoute><ExpertDashboard /></ProtectedRoute>} />
      <Route path="/reviews" element={<ProtectedRoute><MyReviews /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
      <Route path="/billing/cancel" element={<ProtectedRoute><BillingCancel /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <I18nProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
